import React, { useState, useEffect, useContext } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import StoreIcon from "@material-ui/icons/Store";
import { FurnisherApi, FurnisherDto } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { useHistory } from "react-router-dom";
import { SearchBox } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { SchoolContext } from "../../contexts/SchoolContext";

initializeIcons();

export default function CardFurnishers() {
  const { t } = useTranslation();
  const history = useHistory();
  const { furnisherUpdated, setFurnisherUpdated } = useContext(SchoolContext);
  const [furnisherApi] = useState<FurnisherApi>(new FurnisherApi(getApiUrl()));
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [furnishers, setFurnishers] = useState<FurnisherDto[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    setIsLoading(true);
    setFurnisherUpdated(false);
    furnisherApi
      .furnisherGet(true)
      .then((res) => {
        setFurnishers(res);
        setIsLoading(false);
      })
      .catch((err) => setIsLoading(false));
  }, [furnisherApi, furnisherUpdated, setFurnisherUpdated]);

  const filteredFurnishers = furnishers.filter((f) =>
    (f.name ?? "").toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Card>
      <CardHeader title={t("furnishers.title")} />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <SearchBox
              placeholder={t("furnishers.searchPlaceholder")}
              value={searchText}
              onChange={(event, newValue) => setSearchText(newValue ?? "")}
              onClear={() => setSearchText("")}
            />
          </Grid>
        </Grid>
        {!isLoading ? (
          filteredFurnishers.length > 0 ? (
            <List>
              {filteredFurnishers.map((f) => (
                <div key={f.furnisherId}>
                  <ListItem
                    button
                    alignItems="flex-start"
                    onClick={() =>
                      history.push("/furnisher/GetById/" + f.furnisherId)
                    }
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <StoreIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={f.name} />
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          ) : (
            <NoResult />
          )
        ) : (
          <Loading />
        )}
      </CardContent>
    </Card>
  );
}
